import type { AnswerState } from '@repo/contracts/cardfinder/funnel/types';

export const FUNNEL_SESSION_STATUSES = ['in-progress', 'complete'] as const;
export const SAVED_AS_VALUES = ['anonymous', 'authenticated'] as const;

export type FunnelSessionStatus = (typeof FUNNEL_SESSION_STATUSES)[number];
export type SavedAs = (typeof SAVED_AS_VALUES)[number];

export type FunnelSession = {
  answers: AnswerState;
  status: FunnelSessionStatus;
  sessionId: string | null;
  savedAs: SavedAs | null;
};
